// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36z4m","rootNoMargin":"styles_rootNoMargin__2aXRa"};